import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';
import { createRouterLinkClickHandler } from '../../../../hooks/useRouterLinkClick';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import { usePermissions } from '../../../../hooks/usePermissions';
import useGetDriveConfig from '../../../google-drive/api/useGetDriveConfig';
import type { EditableDocument } from '../../external-components/EditDocumentModal/useEditDocumentModal';
import type { DocumentRowData } from '../../types/documentRow';
import { getDriveThumbnailUrl } from '../../utils/getDriveThumbnailUrl';

const THUMBNAIL_SIZE = 80;

type Props = {
  document: DocumentRowData;
};

export function useDocumentRow(props: Props) {
  const navigate = useNavigate();
  const spacePath = useSpacePath();
  const { isAdmin } = usePermissions();
  const { data: driveConfig } = useGetDriveConfig();

  const doc = props.document;
  const type = doc.document_types?.name ?? null;
  const providerHref = doc.provider_id ? spacePath(`/providers/${doc.provider_id}`) : null;
  const createdAt = doc.created_at ? new Date(doc.created_at) : null;

  const editableDocument: EditableDocument = {
    id: doc.id,
    name: doc.name,
    type,
    documentTypeId: doc.document_type_id,
    fileUrl: doc.file_url,
    providerId: doc.provider_id,
    providerName: doc.providers?.name ?? null,
  };

  return {
    isAdmin,
    type,
    editableDocument,
    providerName: doc.providers?.name ?? 'Prestataire',
    providerHref,
    handleProviderClick: providerHref ? createRouterLinkClickHandler(navigate, providerHref) : undefined,
    date: createdAt ? format(createdAt, 'd MMM yyyy', { locale: fr }) : undefined,
    dateTime: createdAt ? format(createdAt, 'yyyy-MM-dd') : undefined,
    thumbnailUrl: driveConfig && type?.toLowerCase() === 'photos'
      ? getDriveThumbnailUrl(doc.file_url, THUMBNAIL_SIZE)
      : null,
  };
}
